module.exports = __webpack_public_path__ + "img/infrasel_8.cbecd727.png";